// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #555 !important;
}

.response-message {
  margin-bottom: 20px;
}

.swal2-icon.swal2-success .swal2-success-ring {
  border: 0.25em solid #00CAFF;
}

.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #00CAFF;
}

.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #00CAFF;
}

.btn-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/auth/components/redefinir-senha/redefinir-senha.component.scss"],"names":[],"mappings":"AAAA;;;;EAII,8CAAA;EACA,yDAAA;EAAA,iDAAA;EACA,wCAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,4BAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,YAAA;AACJ","sourcesContent":["input:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0px 1000px white inset;\n    transition: background-color 5000s ease-in-out 0s;\n    -webkit-text-fill-color: #555 !important;\n}\n\n.response-message {\n    margin-bottom: 20px;\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n    border: 0.25em solid #00CAFF;\n}\n\n.swal2-icon.swal2-success [class^='swal2-success-line'] {\n    background-color: #00CAFF;\n}\n\n.swal2-icon.swal2-success [class^='swal2-success-line'] {\n    background-color: #00CAFF;\n}\n\n.btn-disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
